import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../constant/baseurl";
import { apiCall } from "../../api/index";

const createAccountAsyncThunk = (method, type, contentType, url) =>
  createAsyncThunk(type, async (payload, thunkAPI) => {
    const { data, params } = payload;
    const { dispatch } = thunkAPI;
    console.log("data:::", data);

    let apiUrl = url;
    if (params) {
      Object.keys(params).forEach((key) => {
        apiUrl = apiUrl.replace(`{${key}}`, params[key]);
      });
    }

    const token = localStorage.getItem("token");
    const apiRequest = {
      method: method,
      headers: token
        ? {
            "Content-Type": contentType,
            Authorization: "Token " + token,
          }
        : { "Content-Type": contentType },
      url: `${baseUrl}${apiUrl}`,
      data,
    };

    try {
    
      const res = await apiCall(apiRequest, dispatch);
      const response = res.data;

      if (response.statusFlag === true) {
        console.log(`login action ------ ${type}`, response);
        return response;
      } else {
        console.error(`account action - ${type}`, response);

        // Check if there is an error code in the response
        const errorCode = response.message;

        // You can throw a custom error with the error code
        throw new Error(errorCode);
      }
    } catch (error) {
      throw error;
    }
  });

export const fetchCandidateDetails = createAccountAsyncThunk(
  "post",
  "fetchCandidateDetails",
  "application/json",
  "CompanyDashboard/fetch_candidate_details/"
);

export const getApiClient = createAccountAsyncThunk(
  "post",
  "getApiClient",
  "application/json",
  "ClientPlanDetails/client_service_provider_rates/"
);

export const overallTatPercentage = createAccountAsyncThunk(
  "post",
  "overallTatPercentage",
  "application/json",
  "CompanyDashboard/overall_tat_percentage/"
);

export const candidateStatuscountAmountSpent = createAccountAsyncThunk(
  "post",
  "candidateStatuscountAmountSpent",
  "application/json",
  "CompanyDashboard/fetch_candidate_statuscount_amountspent/"
);

export const candidateChecksCount = createAccountAsyncThunk(
  "post",
  "candidateChecksCount",
  "application/json",
  "CompanyDashboard/company_candidate_get_checks_count/"
);

export const getMonthlyBgvCount = createAccountAsyncThunk(
  "post",
  "getMonthlyBgvCount",
  "application/json",
  "CompanyDashboard/get_mothly_bgv_count/"
);

export const getBgvCount = createAccountAsyncThunk(
  "post",
  "getBgvCount",
  "application/json",
  "CompanyDashboard/get_bgv_count/"
);

export const getCheckAverageDetails = createAccountAsyncThunk(
  "post",
  "getCheckAverageDetails",
  "application/json",
  "CompanyDashboard/get_checks_average_details/"
);


export const CheckInteractivity = createAccountAsyncThunk(
  "post",
  "CheckInteractivity",
  "application/json",
  "CompanyDashboard/candidate_get_checks_code_details/"
);


export const getClientSearchHistory = createAccountAsyncThunk(
  "get",
  "getClientSearchHistory",
  "application/json",
  "CompanyDashboard/client_search_history_fetch/{user_id}"
);






